'use strict'
import {postForm} from './submit'
import {trackEvent} from '../analytics/index'

export function submitContactForm(e) {
  e.preventDefault()

  if (this.checkValidity()) {
    const request = new XMLHttpRequest()

    trackEvent('Contact Form', 'submit')
    postForm(this, this.action, request)
      .catch(err => console.error(err))
      .then(() => {
        loadSuccessPage()
      })
  }

  return false
}

function loadSuccessPage() {
  const formPage = document.querySelector('.contact-form-page')
  const formContainer = document.querySelector('.contact-form__form')
  const successContainer = document.querySelector('.contact-form__success')
  const transitionTiming = 800

  formContainer.classList.add('contact-form--hide')
  successContainer.style.display = 'block'

  window.setTimeout(() => {
    formPage.style.height = `${successContainer.getBoundingClientRect().height}px`
    successContainer.classList.remove('contact-form--hide')
  }, transitionTiming)

  window.setTimeout(() => {
    formContainer.style.display = 'none'
  }, transitionTiming * 2)
}
